import en from "./locales/en.json";
import es from "./locales/es.json";
import pt from "./locales/pt.json";

export const defaultNS = "translation";

export const translationResources = {
  pt: {
    [defaultNS]: pt,
  },
  es: {
    [defaultNS]: es,
  },
  en: {
    [defaultNS]: en,
  },
};
